import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download_production/69e8de6463911b00146c7ee0/servenest/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e8de6463911b00146c7ee0/servenest/src/styles/tailwind.css");
